export const buildCronInterval = ({ scheduleType, dayOfMonth, dayOfWeek, timeOfDay }) => {
  const schedule = String(scheduleType || '').toLowerCase();

  const time = String(timeOfDay || '').trim();
  const [hourStr, minuteStr] = time.split(':');
  const hour = Number(hourStr);
  const minute = Number(minuteStr);

  if (!Number.isInteger(hour) || hour < 0 || hour > 23) return null;
  if (!Number.isInteger(minute) || minute < 0 || minute > 59) return null;

  if (schedule === 'monthly') {
    const dom = Number(dayOfMonth);
    if (!Number.isInteger(dom) || dom < 1 || dom > 28) return null;
    // minute hour dayOfMonth month dayOfWeek
    return `${minute} ${hour} ${dom} * *`;
  }

  if (schedule === 'weekly') {
    const dow = Number(dayOfWeek);
    // UI uses 1..7 (Mon..Sun). cron-parser/node-cron accept 1..7 with 7 = Sunday.
    if (!Number.isInteger(dow) || dow < 1 || dow > 7) return null;
    // minute hour dayOfMonth month dayOfWeek
    return `${minute} ${hour} * * ${dow}`;
  }

  if (schedule === 'daily') {
    // minute hour dayOfMonth month dayOfWeek
    return `${minute} ${hour} * * *`;
  }

  return null;
};

